import type { InspectionColorSet } from '@/constants/inspection-colors'
import { InspectionPhotoField } from './inspection-photo-field'

interface InspectionBeforeAfterPhotosProps {
	beforeSrc?: string | null
	afterSrc?: string | null
	beforeLabel: string
	afterLabel: string
	colors: InspectionColorSet
}

const noop = () => {}

export const InspectionBeforeAfterPhotos = ({
	beforeSrc,
	afterSrc,
	beforeLabel,
	afterLabel,
	colors,
}: InspectionBeforeAfterPhotosProps) => {
	const photos = [
		{ label: beforeLabel, src: beforeSrc },
		{ label: afterLabel, src: afterSrc },
	].filter((photo) => photo.src)

	if (photos.length === 0) return null

	return (
		<div className="flex flex-wrap gap-4">
			{photos.map(({ label, src }) => (
				<div key={label} className="flex min-w-0 flex-col gap-1.5">
					<span className="text-xs font-semibold text-kaefer-medium-grey">
						{label}
					</span>
					<InspectionPhotoField
						attachLabel=""
						altText={label}
						preview={src ?? null}
						onFileChange={noop}
						onRemove={noop}
						colors={colors}
						showRemoveButton={false}
					/>
				</div>
			))}
		</div>
	)
}
